// Lead statuses themselves are per-company now (see services/leadService's
// getLeadStatuses / Settings > Lead Statuses) — only the handful of things
// that are genuinely fixed across every company stay here.

// Lead stages
export const LEAD_STAGES = ['Cold', 'Warm', 'Hot'];

// Reasons offered on the Lost flow
export const LOST_REASONS = ['Price', 'Timing', 'Chose another supplier', 'No budget', 'Went quiet', 'Other'];

// Activity composer types for the lead's activity panel
export const LEAD_NOTE_TYPES = [
  { value: 'call', label: 'Call' },
  { value: 'email', label: 'Email' },
  { value: 'meeting', label: 'Meeting' },
  { value: 'note', label: 'Note' },
];

// Stage colors for UI
export const STAGE_COLORS = {
  Cold: '#94a3b8',    // Slate
  Warm: '#fb923c',    // Orange
  Hot: '#dc2626'      // Red
};

// Helper to get stage color
export const getStageColor = (stage) =>
  STAGE_COLORS[stage] || STAGE_COLORS.Cold;
